import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, mergeProps as _mergeProps, withKeys as _withKeys, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, isRef as _isRef } from "vue"

const _hoisted_1 = { class: "support" }
const _hoisted_2 = { class: "app-wrapper" }
const _hoisted_3 = { class: "section-header" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", null, null, -1)
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { class: "emq-table-footer" }

import { getQaaList, deleteQaa } from '@/api/operation'
import { SEARCH_FORM_RES_PROPS as colProps } from '@/common/constants'
import CommonPagination from '@/components/commonPagination.vue'
import useI18nTl from '@/hooks/useI18nTl'
import usePaginationRemember from '@/hooks/usePaginationRemember'
import usePaginationWithHasNext from '@/hooks/usePaginationWithHasNext'
import { Refresh, RefreshLeft, Search, Plus } from '@element-plus/icons-vue'
import { pick } from 'lodash'
import { ElMessage, ElMessageBox } from 'element-plus'
import useProtocolEnums from '@/hooks/useProtocolEnums'
import { throttleBtn } from '@/common/tools'
import QAAUpsert from './components/QAAUpsert.vue'
import { checkMenuShow, isSuperadmin } from '@/store/tool'
import PermissionLink from '@/components/PermissionLink.vue'


import { computed, defineComponent, onMounted, ref } from 'vue'

const __default__ = defineComponent({
  name: 'Qaa',
})

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const { langOptions } = useProtocolEnums()

const { t } = useI18nTl('Operatoion')

const showDialog = ref(false)
const showData = ref({})
const showDialogIsEdit = ref(false)
const showMoreQuery = ref(false)
const tableData = ref([])
const lockTable = ref(false)
const TableCom = ref()
const params = ref({})
const fuzzyParams = ref<Record<string, any>>({})
const { pageMeta, pageParams, initPageMeta, setPageMeta, toPageMeta } = usePaginationWithHasNext()
const { updateParams } = usePaginationRemember('evses-detail')

const createdQaa = () => {
  showData.value = {}
  showDialogIsEdit.value = false
  showDialog.value = true
}
const editQaa = (row: any) => {
  showData.value = row
  showDialogIsEdit.value = true
  showDialog.value = true
}

const formatText = (text: string) => {
  // 将 \n 替换为 <br> 标签
  return text.replace(/\n/g, '<br>')
}

const deleteqaa = async (row: any) => {
  try {
    await ElMessageBox.confirm(t('Base.confirmDelete'), {
      confirmButtonText: t('Base.confirm'),
      cancelButtonText: t('Base.cancel'),
      confirmButtonClass: 'confirm-danger',
      type: 'warning',
    })
    await deleteQaa({ qaaid: row.id })
    ElMessage.success(t('Base.deleteSuccess'))
    loadTables()
    return Promise.resolve()
  } catch (error) {
    console.error(error)
    return Promise.reject()
  }
}

const handleSearch = async () => {
  params.value = genQueryParams(fuzzyParams.value)
  loadTables()
}

const handleReset = () => {
  fuzzyParams.value = {}
  handleSearch()
}

const isadmin = computed(() => {
  return isSuperadmin()
})

const genQueryParams = (params: Record<string, any>) => {
  console.log('params', params)
  let newParams: Record<string, any> = {}
  const { lang } = params
  newParams = {
    lang: lang || undefined,
  }
  return newParams
}

const loadTables = async () => {
  lockTable.value = true
  const sendParams = {
    ...params.value,
    pageReq: {
      ...pageParams.value,
    },
  }

  try {
    const { list = [], pageReply = {} } = await getQaaList(sendParams)
    console.log(list, pageReply, 'sendParams', sendParams)
    const meta = toPageMeta(sendParams.pageReq, pageReply)
    tableData.value = list
    // 测试图片预览
    // tableData.value = [
    //   {
    //     id: '544365836224233517',
    //     q: 'test',
    //     a: 'test',
    //     images: ['https://fastly.picsum.photos/id/467/400/400.jpg?hmac=lRidWWTdbH4YT0Hg44VIYU8SQQ0YtMrT0dfg4FkcE6o'],
    //     language: 0,
    //     lang: 'zh_cn',
    //     operatorID: '543618986793893968',
    //     operatorName: 'xxx',
    //   },
    // ]
    setPageMeta(meta)
    updateParams({ ...pick(meta, ['limit', 'page']), ...params.value })
  } catch (error) {
    tableData.value = []
    initPageMeta()
  } finally {
    lockTable.value = false
  }
}
const loadDatasRefreshLimit = throttleBtn(loadTables)
onMounted(() => {
  loadTables()
})

return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _directive_role = _resolveDirective("role")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_form, {
      class: "search-wrapper",
      onKeyup: _withKeys(handleSearch, ["enter"])
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_row, { gutter: 20 }, {
          default: _withCtx(() => [
            _createVNode(_component_el_col, _normalizeProps(_guardReactiveProps(_unref(colProps))), {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: fuzzyParams.value.lang,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((fuzzyParams.value.lang) = $event)),
                  prop: "lang"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(langOptions), (item) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        label: item.label,
                        value: item.value,
                        key: item.value
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }, 16),
            (showMoreQuery.value)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [], 64))
              : _createCommentVNode("", true),
            _createVNode(_component_el_col, _mergeProps(_unref(colProps), { class: "col-oper" }), {
              default: _withCtx(() => [
                _createVNode(_component_el_button, {
                  type: "primary",
                  plain: "",
                  icon: _unref(Search),
                  onClick: handleSearch
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('Base.search')), 1)
                  ]),
                  _: 1
                }, 8, ["icon"]),
                _createVNode(_component_el_button, {
                  icon: _unref(RefreshLeft),
                  onClick: handleReset
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('Base.reset')), 1)
                  ]),
                  _: 1
                }, 8, ["icon"])
              ]),
              _: 1
            }, 16)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["onKeyup"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _withDirectives((_openBlock(), _createBlock(_component_el_button, {
          type: "primary",
          icon: _unref(Plus),
          onClick: createdQaa
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('Base.create')), 1)
          ]),
          _: 1
        }, 8, ["icon"])), [
          [_directive_role, 'supportFAQAdd']
        ]),
        _createVNode(_component_el_button, {
          type: "primary",
          plain: "",
          icon: _unref(Refresh),
          onClick: _unref(loadDatasRefreshLimit)
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('Base.refresh')), 1)
          ]),
          _: 1
        }, 8, ["icon", "onClick"])
      ]),
      _withDirectives((_openBlock(), _createBlock(_component_el_table, {
        data: tableData.value,
        ref_key: "TableCom",
        ref: TableCom,
        "row-key": "id"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_table_column, {
            prop: "operatorName",
            "min-width": "120",
            label: _ctx.$t('Operation.operator')
          }, {
            default: _withCtx(({ row }) => [
              _createVNode(PermissionLink, {
                to: {
                name: 'operator-detail',
                params: { id: row.operatorID },
              },
                role: ['operatorInfo'],
                isLink: row.operatorID !== '0'
              }, {
                default: _withCtx(() => [
                  (row.operatorID == '0')
                    ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_ctx.$t('Base.system')), 1))
                    : (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(row.operatorName), 1))
                ]),
                _: 2
              }, 1032, ["to", "isLink"])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            prop: "q",
            "show-overflow-tooltip": true,
            "min-width": "120",
            label: _ctx.$t('Base.q')
          }, null, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            prop: "a",
            "show-overflow-tooltip": true,
            "min-width": "280",
            label: _ctx.$t('Base.a')
          }, {
            default: _withCtx(({ row }) => [
              _createElementVNode("div", null, _toDisplayString(row.a), 1)
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            prop: "lang",
            "min-width": "60",
            label: _ctx.$t('Base.language')
          }, {
            default: _withCtx(({ row }) => [
              _createVNode(_component_el_select, {
                modelValue: row.lang,
                "onUpdate:modelValue": ($event: any) => ((row.lang) = $event),
                prop: "lang",
                disabled: true,
                class: "no-arrow"
              }, {
                suffix: _withCtx(() => []),
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(langOptions), (item) => {
                    return (_openBlock(), _createBlock(_component_el_option, {
                      label: item.label,
                      value: item.value,
                      key: item.value
                    }, null, 8, ["label", "value"]))
                  }), 128))
                ]),
                _: 2
              }, 1032, ["modelValue", "onUpdate:modelValue"])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            "min-width": "60",
            label: _ctx.$t('Base.operation'),
            "class-name": "table-operation"
          }, {
            default: _withCtx(({ row }) => [
              (
                _unref(isadmin) || (_unref(checkMenuShow)('supportFAQDelete') && !_unref(isadmin) && row.operatorID != '0')
              )
                ? (_openBlock(), _createBlock(_component_el_button, {
                    key: 0,
                    size: "small",
                    plain: "",
                    onClick: ($event: any) => (deleteqaa(row))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('Base.delete')), 1)
                    ]),
                    _: 2
                  }, 1032, ["onClick"]))
                : _createCommentVNode("", true),
              (
                _unref(isadmin) || (_unref(checkMenuShow)('supportFAQDelete') && !_unref(isadmin) && row.operatorID != '0')
              )
                ? (_openBlock(), _createBlock(_component_el_button, {
                    key: 1,
                    size: "small",
                    plain: "",
                    onClick: ($event: any) => (editQaa(row))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('Base.edit')), 1)
                    ]),
                    _: 2
                  }, 1032, ["onClick"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["label"])
        ]),
        _: 1
      }, 8, ["data"])), [
        [
          _directive_loading,
          lockTable.value,
          void 0,
          { lock: true }
        ]
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createVNode(CommonPagination, {
          metaData: _unref(pageMeta),
          "onUpdate:metaData": _cache[1] || (_cache[1] = ($event: any) => (_isRef(pageMeta) ? (pageMeta).value = $event : null)),
          onLoadPage: loadTables
        }, null, 8, ["metaData"])
      ]),
      _createVNode(QAAUpsert, {
        modelValue: showDialog.value,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((showDialog).value = $event)),
        isEdit: showDialogIsEdit.value,
        faqInfo: showData.value,
        onSubmitted: loadTables
      }, null, 8, ["modelValue", "isEdit", "faqInfo"])
    ])
  ]))
}
}

})